/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTaskExecutionResponse
 */
export interface UpdateTaskExecutionResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskExecutionResponse
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTaskExecutionResponse
     */
    taskExecutionId: number;
}

/**
 * Check if a given object implements the UpdateTaskExecutionResponse interface.
 */
export function instanceOfUpdateTaskExecutionResponse(value: object): value is UpdateTaskExecutionResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('taskExecutionId' in value) || value['taskExecutionId'] === undefined) return false;
    return true;
}

export function UpdateTaskExecutionResponseFromJSON(json: any): UpdateTaskExecutionResponse {
    return UpdateTaskExecutionResponseFromJSONTyped(json, false);
}

export function UpdateTaskExecutionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTaskExecutionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'taskExecutionId': json['task_execution_id'],
    };
}

export function UpdateTaskExecutionResponseToJSON(json: any): UpdateTaskExecutionResponse {
    return UpdateTaskExecutionResponseToJSONTyped(json, false);
}

export function UpdateTaskExecutionResponseToJSONTyped(value?: UpdateTaskExecutionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'task_execution_id': value['taskExecutionId'],
    };
}

